<template>
  <b-container class="">
    <h1>Mon profil</h1>

    <b-form v-if="getUserSession()" @submit.prevent="onSubmit">
      <b-form-group label="Prénom" label-cols="1">
        <b-input type="text" :state="isValid(user.firstName)" placeholder="Votre prénom" v-model="user.firstName"></b-input>
      </b-form-group>

      <b-form-group label="Nom" label-cols="1">
        <b-input type="text" :state="isValid(user.lastName)" placeholder="Votre nom" v-model="user.lastName"></b-input>
      </b-form-group>

      <b-form-group label="Email" label-cols="1">
        <b-input type="text" :state="isValid(user.email)" placeholder="Votre email" v-model="user.email" aria-describedby="input-help"></b-input>
        <b-form-text id="input-help">Changer d'adresse email nécessite de se reconnecter.</b-form-text>
      </b-form-group>

      <b-form-group label="Mot de passe" label-cols="1">
        <b-input type="password" placeholder="Votre nouveau mot de passe (laissez vide pour ne pas le changer)" v-model="user.password" aria-describedby="input-password-help"></b-input>
        <b-form-text id="input-password-help">Changer de mot de passe nécessite de se reconnecter.</b-form-text>
      </b-form-group>

      <b-form-group>
        <b-button type="submit" variant="primary">Sauvegarder</b-button>
      </b-form-group>
    </b-form>

  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Profile',
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        email: null,
      },
      userData: null,
      userClone: null,
      toastMessage: null,
      toastType: null,
    };
  },
  methods: {
    ...mapActions([
      'getMe',
    ]),
    ...mapGetters([
      'getUserSession',
    ]),
    onSubmit() {
      // All the fields are mandatory
      if (this.userData.firstName != '' && this.userData.lastName != '' && this.userData.email != '') {
        axios.patch('users/' + this.userData.id, {
          firstName: this.userData.firstName,
          lastName: this.userData.lastName,
          email: this.userData.email,
          password: this.userData.password
        })
            .then((response) => {
              // If the user has changed their email address or password, we shall log them out
              if (this.userData.email != this.userClone.email || (this.userData.password && this.userData.password != '' && this.userData.password != null)) {
                this.toastMessage = 'Profil mis à jour avec succès, merci de vous reconnecter.';
                this.toastType = 'success';

                this.$router.push('logout');
              } else {
                this.userData = response.data.user;
                this.toastType = 'success';
                this.toastMessage = 'Profil mis à jour avec succès.';
              }

            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 500) {
                  this.toastMessage = 'Impossible de modifier ce profil - Adresse email déjà utilisée.';
                  this.toastType = 'danger';
                } else if (error.response.status === 400) {
                  this.toastMessage = 'Impossible de modifier ce profil - Adresse email invalide.';
                  this.toastType = 'danger';
                } else {
                  console.error(response);
                }
              }
            })
            .finally(() => {
              const toast = {
                show: true,
                message: this.toastMessage,
                variant: this.toastType,
                duration: 3000,
              };
              this.$store.commit('setGlobalToaster', toast);
            });
      }
    },
    isValid(val) {
      if (val == '' || val == null) {
        return false;
      }
    }
  },
  mounted() {
    axios.get('/users/me')
      .then((response) => {
        this.userData = response.data;
        this.userClone = response.data;
      });
  },
  watch: {
    userData(newVal) {
      this.user = newVal;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/profile/Profile.vue